import { MakeCall } from './createMakeCall';

export interface SurveyData {
  isHa?: boolean;
  isRented?: boolean;
  isLocalStudent?: boolean;
  reason?: string;
  how?: string;
  why?: string;
}

export default (makeCall: MakeCall) => (listingId: number, data: SurveyData) => {
  return makeCall<undefined>('POST', `/api/v2/listing/${listingId}/survey`, {
    data,
  });
};
